import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatMultipleRows',
})
export class FormatMultipleRowsPipe implements PipeTransform {
  transform(value: string) {
    if (!value) {
      return null;
    }

    const parts = value.split('\n');
    const htmlContent = parts.join(' ');

    return parts.length > 1 ? `${htmlContent}...` : htmlContent;
  }
}
